import React from 'react';

import { IMetalGroup } from '../../../../sharedInterfaces';

import {
  MaterialSectionContainer,
  MaterialSectionHeaderBottomText,
  MaterialSectionHeaderContainer,
  MaterialSectionHeaderLeftSide,
  MaterialSectionHeaderRightSide,
  MaterialSectionHeaderTopText,
  MaterialsTabContainer
} from './MaterialsLUXE-styled';
import { isLowHeight, isMobile } from '../../../shared/UIHelpers/Functions/Functions';
import { TabHeader } from '../Tabs-styled';
import { GridMenuItem } from '../../UIHelpersLUXE/GridMenu/GridMenuItem';
import { PuritySelector } from './PuritySelector';
import { GridMenuOptionsContainer } from '../../UIHelpersLUXE/GridMenu/GridMenu-styled';


interface Props {
  metalGroup:IMetalGroup,
  onParameterChange:(param:'material'|'surface'|'purity',value:any)=>void,
  limitedMaterials:string[],
  assetURI:string,
  mobile:boolean,
  menuHeight:number,
  menuScaleFactor:number
}

interface State {
}


export default class MaterialsDesktop extends React.Component<Props,State> {
  constructor(props: Props) {
    super(props);
  }

  render = () => {
    const {
      metalGroup,
      onParameterChange,
      limitedMaterials,
      assetURI,
      mobile,
      menuHeight,
      menuScaleFactor
    } = this.props;

    const {
      name,
      material,
      materialOptions,
      surface,
      surfaceOptions,
      purity,
      purityOptions
    } = metalGroup;

    return (
      <MaterialsTabContainer mobile={mobile} menuHeight={menuHeight} menuScaleFactor={menuScaleFactor}>
        <TabHeader>
          CHOOSE {metalGroup.name} METAL
        </TabHeader>

        {(materialOptions.length > 0) && 
          <MaterialSectionContainer>
            <MaterialSectionHeaderContainer>
              <MaterialSectionHeaderLeftSide>
                <MaterialSectionHeaderTopText>Metal</MaterialSectionHeaderTopText>
                <MaterialSectionHeaderBottomText>{metalGroup.material}</MaterialSectionHeaderBottomText>
              </MaterialSectionHeaderLeftSide>

              <MaterialSectionHeaderRightSide>
                {purityOptions && purityOptions.length > 0 &&
                  <PuritySelector
                    selectedPurity={purity}
                    purityOptions={purityOptions}
                    changePurity={(purity) => onParameterChange('purity', purity)}
                  />
                }
              </MaterialSectionHeaderRightSide>
            </MaterialSectionHeaderContainer>

            <GridMenuOptionsContainer>
              {materialOptions.map(option =>
                <GridMenuItem
                  option={option}
                  imgName={`${option} ${surface}`}
                  assetURI={`${assetURI}/images/materials/`}
                  isSelected={option === material}
                  onClick={(value) => onParameterChange('material', value)}
                  key={`${name}---material-${option.toLowerCase().replace(' ', '-')}`}
                  isMobile={isMobile()}
                  isLowHeight={isLowHeight()}
                />
              )}
            </GridMenuOptionsContainer>
          </MaterialSectionContainer>
        }
        
        {(surfaceOptions.length > 0) && !limitedMaterials.includes(material) && 
          <MaterialSectionContainer>
            <MaterialSectionHeaderContainer>
              <MaterialSectionHeaderLeftSide>
                <MaterialSectionHeaderTopText>Finishing</MaterialSectionHeaderTopText>
                <MaterialSectionHeaderBottomText>{metalGroup.surface}</MaterialSectionHeaderBottomText>
              </MaterialSectionHeaderLeftSide>
            </MaterialSectionHeaderContainer>

            <GridMenuOptionsContainer>
              {surfaceOptions.map(option =>
                <GridMenuItem
                  option={option}
                  imgName={`${material} ${option}`}
                  assetURI={`${assetURI}/images/materials/`}
                  isSelected={option === surface}
                  onClick={(value) => onParameterChange('surface', value)}
                  key={`${name}---surface-${option.toLowerCase().replace(' ', '-')}`}
                  isMobile={isMobile()}
                  isLowHeight={isLowHeight()}
                />
              )}
            </GridMenuOptionsContainer>
          </MaterialSectionContainer>
        }
      </MaterialsTabContainer>
    )
  }
}